export const descriptionsUploadPortfolio = [
    {subtitle: 'Loading...', description: 'Tailoring your unique DeFi strategy'},
    {subtitle: 'Diving deep...', description: 'Fishing for golden pools in the DeFi ocean'},
    {subtitle: 'Harvesting...', description: 'Picking the ripest yields from the DeFi fields'},
    {subtitle: 'Optimizing...', description: 'Strategically aligning your crypto stars'},
    {subtitle: 'Assembling...', description: 'Your portfolio is coming together piece by piece'},
    {subtitle: 'Hang tight...', description: 'Prepping your portfolio for lift-off'},
    {subtitle: 'Loading...', description: 'Spinning up the gains machine'},
]
